import {VStack} from 'platform/foundation';

import {omit} from 'ramda';

import {MoneyText, type MoneyTextProps} from '@dms/features/new-vehicle';

import {type Nullish} from 'shared/web';

import {GrossPriceText} from './components/GrossPriceText';

export function PriceWithGross(props: MoneyTextProps & {vatRate: string | Nullish}) {
  const align = props.align ?? 'right';
  return (
    <VStack spacing={0} align={align === 'right' ? 'flex-end' : 'flex-start'}>
      <MoneyText {...omit(['vatRate'], props)} align={align} />
      <GrossPriceText
        net={props.amount}
        currency={props.currency}
        vatRate={props.vatRate}
        align={align}
      />
    </VStack>
  );
}
